import {
  decodeValues,
  getLayer,
  IField,
  IQueryFeaturesResponse,
  queryFeatures,
} from "@esri/arcgis-rest-feature-service";
import { Layer } from "../interfaces/layer";

export type ArcgisTokenMap = Record<
  string,
  { token: string; expires?: number } | null | undefined
>;

const getTokenForLayer = (
  layerUrl?: string,
  tokens?: ArcgisTokenMap,
): string | undefined => {
  if (!layerUrl || !tokens) return undefined;
  try {
    const host = new URL(layerUrl).host;
    const tokenInfo = tokens[host];
    if (tokenInfo && (!tokenInfo.expires || tokenInfo.expires > Date.now())) {
      return tokenInfo.token;
    }
  } catch {
    return undefined;
  }
  return undefined;
};

export const GetQueryFeatures = async (
  layer: Layer,
  excludeFieldDecode: string[] = [],
  tokens?: ArcgisTokenMap,
): Promise<IQueryFeaturesResponse> => {
  const token = getTokenForLayer(layer.url, tokens);
  const layerDef = await getLayer({ url: layer.url!, authentication: token });
  let response = (await queryFeatures({
    url: layer.url!,
    where: layer.style2D?.query,
    authentication: token,
  })) as IQueryFeaturesResponse;
  response = await decodeValues({
    queryResponse: response!,
    fields: layerDef.fields?.filter(
      (field) => !excludeFieldDecode.includes(field.name),
    ),
  });
  response.fields = layerDef.fields;
  return response;
};

export const GetFields = async (
  layer: Layer,
  tokens?: ArcgisTokenMap,
): Promise<IField[] | undefined> => {
  const token = getTokenForLayer(layer.url, tokens);
  const layerDef = await getLayer({ url: layer.url!, authentication: token });
  return layerDef.fields;
};
